import { useEffect, useRef } from 'react';

//Отслеживание клика вне компонента
export default function useOutsideClick(onOutsideClick) {
    const ref = useRef();

    useEffect(() => {
        function handleClick(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                onOutsideClick();
            }
        }

        document.addEventListener('mousedown', handleClick);

        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, [onOutsideClick]);

    return ref;
};